// diff 着色显示（+ 绿 / - 红）
import { useMemo } from "react";
import { diffStats, parseUnifiedDiff } from "../lib/diff";

export function DiffView({ diff, maxHeight }: { diff: string; maxHeight?: number }) {
  const lines = useMemo(() => parseUnifiedDiff(diff), [diff]);
  const st = diffStats(lines);
  if (!lines.length) return <div className="muted small">（没有改动内容）</div>;
  return (
    <div>
      <div className="small muted" style={{ marginBottom: 4 }}>
        <span className="ok-text">+{st.added}</span> / <span className="err">-{st.removed}</span> 行
      </div>
      <div className="diff" translate="no" style={maxHeight ? { maxHeight } : undefined} data-testid="diff">
        {lines.map((l, i) => (
          <div key={i} className={l.type}>
            {l.text || " "}
          </div>
        ))}
      </div>
    </div>
  );
}
